export default "__VITE_ASSET__CrnqXXkV__"